export default __webpack_public_path__ + "static/media/1996.572d780f.png";